import i18next from 'i18next';
import i18NextVue from 'i18next-vue'
import LanguageDetector from 'i18next-browser-languagedetector'
// English texts bundled with the app: the first screen does not wait for Locize, keys missing in the loaded language
// fall back to them, and they are all the texts when Locize cannot be reached. The build refreshes them from Locize
// (.gitlab-ci.yml); the committed copy is the fallback of that step.
import fallbackTranslations from './translations.en-US.json'

const configureI18next = () => {
  i18next
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en-US',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'airelink:language',
      caches: ['localStorage'],
    },
    debug: true,
    resources: {'en-US': {translation: fallbackTranslations}},
  })
}

export default function (app) {
  configureI18next()
  app.use(i18NextVue, { i18next })
  return app
}
